<template lang="pug">
  .container
    .row
      .box
        .col-lg-12
          h2 Contact Us
          p Got any questions not answered here?  Fill in the information below and we'll get back to you as soon as we can!
          .alert.alert-success(v-if='showSuccess', role="alert") Email sent!
          .alert.alert-danger(v-if='showError', role="alert") Whoops!  Something went wrong sending your email, try again!  Please make sure everything is filled out
          .row
            .form-group.col-lg-4
              label Name
              input.form-control(type="text" placeholder='required' v-model='name')
            div.col-lg-4
              label Email Address
              input.form-control(type="email", v-bind:class='emailClass', placeholder='required', v-model='email', aria-describedby="inputSuccess2Status")

            .form-group.col-lg-4
              label Phone Number
              input.form-control(type="tel" v-model='phone')
            .clearfix
            .form-group.col-lg-12
              label Message
              textarea.form-control(v-model='message', placeholder='required', rows="6")
            .form-group.col-lg-12
              button.btn.btn-success(v-on:click='send', v-bind:disabled='shouldNotSend') Submit
                span(v-if='isSending') &nbsp;&nbsp;
                  i.fas.fa-sync.fa-spin
</template>

<script>
  export default {
    name: 'Contact',
    props: {
    },
    data() {
      return {
        isLoading: true,
        name: '',
        email: '',
        phone: '',
        message: '',
        isSending: false,
        showSuccess: false,
        showError: false
      };
    },
    computed: {
      shouldNotSend: function () {
        return this.isSending ||
              (_.isEmpty(this.name) || _.isEmpty(this.email) || _.isEmpty(this.message)) ||
              !this.emailIsValid();
      },
      emailClass: function () {
        const c = {
          'form-group': true,
          'is-valid': this.shouldShowEmailSuccess(),
          'is-invalid': this.shouldShowEmailError(),
          'has-feedback': true
        };
        return c;
      }
    },
    methods: {
      send: function () {
        const self = this;
        this.isSending = true;
        this.showSuccess = false;
        this.showError = false;

        const params = {
          simpo: '',
          name: this.name,
          email: this.email,
          body: this.message,
          phone: this.phone
        };
        const options = {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(params)
        };
        fetch('https://api.hawaiican.org/1/contact', options).then(response => response.json()
        ).then((data) => {
          if (data === 'Email sent') {
            self.isSending = false;
            self.showSuccess = true;
            self.resetData();
          }
          else {
            self.isSending = false;
            self.showError = true;
          }
        }).catch((error) => {
          self.isSending = false;
          self.showError = true;
        });
      },
      resetData: function () {
        this.name = '';
        this.email = '';
        this.phone = '';
        this.message = '';
      },
      emailIsValid: function () {
        return !_.isEmpty(this.email) && this.email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      },
      shouldShowEmailSuccess: function () {
        return !_.isEmpty(this.email) && this.emailIsValid();
      },
      shouldShowEmailError: function () {
        return !_.isEmpty(this.email) && !this.emailIsValid();
      }
    }
  };
</script>

<style scoped>
  .glyphicon {
    margin-right: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue